<template>
  <div class="invoice-filters mt-4 mb-3">
    <b-form>
      <b-row class="filter-row">
        <b-col class="filter-col">
          <label class="d-block filter-label">
            <drip-card
              class="filter-card pending"
              :class="{ checked: filters.indexOf('pending') > -1 }"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="filter-checkbox custom-control-inline"
                  v-model="filters"
                  value="pending"
                />
                <span class="display-label">
                  {{ $t('invoiceFilters.pending') }}
                </span>
              </div>
              <span class="display-count">
                {{ counter('pending') }}
                <b-link class="only" @click="handleOnly('pending')">{{
                  $t('invoices.index.only')
                }}</b-link>
              </span>
            </drip-card>
          </label>
        </b-col>
        <b-col class="filter-col">
          <label class="d-block filter-label">
            <drip-card
              class="filter-card processing"
              :class="{ checked: filters.indexOf('processing') > -1 }"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="filter-checkbox custom-control-inline"
                  v-model="filters"
                  value="processing"
                />
                <span class="display-label">
                  {{ $t('invoiceFilters.processing') }}
                </span>
              </div>
              <span class="display-count">
                {{ counter('processing') }}
                <b-link class="only" @click="handleOnly('processing')">{{
                  $t('invoices.index.only')
                }}</b-link>
              </span>
            </drip-card>
          </label>
        </b-col>
        <b-col class="filter-col">
          <label class="d-block filter-label">
            <drip-card
              class="filter-card approved"
              :class="{ checked: filters.indexOf('approved') > -1 }"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="filter-checkbox custom-control-inline"
                  v-model="filters"
                  value="approved"
                />
                <span class="display-label">
                  {{ $t('invoiceFilters.approved') }}
                </span>
              </div>
              <span class="display-count">
                {{ counter('approved') }}
                <b-link class="only" @click="handleOnly('approved')">{{
                  $t('invoices.index.only')
                }}</b-link>
              </span>
            </drip-card>
          </label>
        </b-col>
        <b-col class="step-transition-col">
          <div class="step-transition">
            <b-icon-chevron-right />
          </div>
        </b-col>
        <b-col class="filter-col">
          <label class="d-block filter-label">
            <drip-card
              class="filter-card advanced"
              :class="{ checked: filters.indexOf('advanced') > -1 }"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  v-model="filters"
                  class="filter-checkbox custom-control-inline"
                  value="advanced"
                />
                <span class="display-label">
                  {{ $t('invoiceFilters.advanced') }}
                </span>
              </div>
              <span class="display-count">
                {{ counter('advanced') }}
                <b-link class="only" @click="handleOnly('advanced')">{{
                  $t('invoices.index.only')
                }}</b-link>
              </span>
            </drip-card>
          </label>
        </b-col>
        <b-col class="filter-col">
          <label class="d-block filter-label">
            <drip-card
              class="filter-card paid"
              :class="{ checked: filters.indexOf('paid') > -1 }"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  v-model="filters"
                  class="filter-checkbox custom-control-inline"
                  value="paid"
                />
                <span class="display-label">
                  {{ $t('invoiceFilters.paid') }}
                </span>
              </div>
              <span class="display-count">
                {{ counter('paid') }}
                <b-link class="only" @click="handleOnly('paid')">{{
                  $t('invoices.index.only')
                }}</b-link>
              </span>
            </drip-card>
          </label>
        </b-col>
        <b-col class="step-transition-col">
          <div class="step-transition">
            <b-icon-chevron-right />
          </div>
        </b-col>
        <b-col class="filter-col">
          <label class="d-block filter-label">
            <drip-card
              class="filter-card settled"
              :class="{ checked: filters.indexOf('settled') > -1 }"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  v-model="filters"
                  class="filter-checkbox custom-control-inline"
                  value="settled"
                />
                <span class="display-label">
                  {{ $t('invoiceFilters.settled') }}
                </span>
              </div>
              <span class="display-count">
                {{ counter('settled') }}
                <b-link class="only" @click="handleOnly('settled')">{{
                  $t('invoices.index.only')
                }}</b-link>
              </span>
            </drip-card>
          </label>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import DripCard from '../../../components/drip/ui/Card'

export default {
  data() {
    return {
      filters: []
    }
  },
  mounted() {
    this.filters = this.value
  },
  props: ['value', 'invoiceMeta'],
  watch: {
    filters() {
      const newValue =
        this.filters && this.filters.filter((x) => !this.value.includes(x))
      if (newValue[0])
        this.$mpTrack(`Clicked on invoice list filter - ${newValue[0]}`)
      this.$emit('input', this.filters)
    }
  },
  methods: {
    counter(stage) {
      let count = 0
      if (this.invoiceMeta) {
        this.invoiceMeta.groups[stage].forEach((stageThing) => {
          if (typeof this.invoiceMeta.counters[stageThing] !== 'undefined') {
            count += this.invoiceMeta.counters[stageThing]
          }
        })
      }
      return count
    },
    refreshFilters() {
      this.filters = this.value
    },
    handleOnly(value) {
      if (value) this.$mpTrack(`Clicked on invoice list filter - ${value} only`)
      this.filters = [value]
    }
  },
  components: {
    DripCard
  }
}
</script>
<style lang="scss">
@import '../../../assets/scss/variables';

.filter-row.row {
  // increase specificity for prod builds
  margin-right: -5px;
  margin-left: -5px;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  & > .col {
    padding-left: 5px;
    padding-right: 5px;
  }
  .step-transition-col {
    flex-shrink: 1;
    flex-grow: 0;
    display: flex;
  }
}

.filter-col {
  flex: 1;
}

.filter-label {
  cursor: pointer;
  &:hover {
    > div {
      background: $grey;
    }
  }
}

.filter-card.card {
  position: relative;
  overflow: hidden;

  &.checked {
    .display-label,
    .display-count {
      font-weight: 600;
    }
  }

  .card-body {
    padding-top: 14px;
    padding-bottom: 12px;
    &:before {
      content: '';
      width: 5px;
      height: 100%;
      background: red;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  &.pending {
    .card-body {
      &:before {
        background: $pending-color;
      }
    }
  }
  &.processing {
    .card-body {
      &:before {
        background: $processing-color;
      }
    }
  }
  &.approved {
    .card-body {
      &:before {
        background: $approved-color;
      }
    }
  }
  &.advanced {
    .card-body {
      &:before {
        background: $advanced-color;
      }
    }
  }
  &.paid {
    .card-body {
      &:before {
        background: $paid-color;
      }
    }
  }
  &.settled {
    .card-body {
      &:before {
        background: $settled-color;
      }
    }
  }

  .only {
    visibility: hidden;
    margin-left: 4px;
    font-size: 12px;
    font-weight: bold;
  }

  &:hover {
    .only {
      visibility: visible;
    }
  }
}

.display-label {
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1.2px;
}

.display-count {
  display: flex;
  align-items: center;
  color: #000;
  clear: left;
  font-size: 18px;
  font-family: $montserrat;
  &:before {
    content: ' ';
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 10.5px;
    border-radius: 100%;
    margin-bottom: 2px;
  }
  .filter-card.processing & {
    &:before {
      background: $processing-color;
    }
  }
  .filter-card.pending & {
    &:before {
      background: $pending-color;
    }
  }
  .filter-card.advanced & {
    &:before {
      background: $advanced-color;
    }
  }
  .filter-card.approved & {
    &:before {
      background: $approved-color;
    }
  }
  .filter-card.paid & {
    &:before {
      background: $paid-color;
    }
  }
  .filter-card.settled & {
    &:before {
      background: $settled-color;
    }
  }
}

.filter-checkbox.custom-control-inline {
  margin-right: 0;
  .custom-control-label {
    &:before,
    &:after {
      width: 15px;
      height: 15px;
    }
    &:before {
      background-color: transparent;
      border: 1px solid #8798ad;
      border-radius: 1px;
      opacity: 0.3;
    }
  }
  .custom-control-input:checked ~ .custom-control-label {
    &:before {
      border: 0;
      opacity: 1;
      .filter-card.pending & {
        background-color: $pending-color;
      }
      .filter-card.processing & {
        background-color: $processing-color;
      }
      .filter-card.approved & {
        background-color: $approved-color;
      }
      .filter-card.advanced & {
        background-color: $advanced-color;
      }
      .filter-card.paid & {
        background-color: $paid-color;
      }
      .filter-card.settled & {
        background-color: $settled-color;
      }
    }
  }
}

.step-transition {
  background: #f3f4f6;
  display: inline-block;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  border-radius: 100%;
  padding-left: 2px;
  align-self: center;
}
@include media-breakpoint-down(sm) {
  .invoice-filters {
    .filter-row.row {
      overflow-x: scroll;
      .step-transition-col {
        display: none;
      }
      .filter-card {
        .card-body {
          min-width: 9rem;
          .only {
            visibility: visible;
          }
        }
      }
    }
  }
}
</style>
